import { Ref } from 'vue';
import {
  SizeTypeLabel,
  RoofTypeLabel,
  CabinTypeLabel,
  DrivetrainLabel,
  EngineTypeLabel,
} from '@/types';
import { getDefaultLocaleValue } from '../locales/default';

type TransmissionMode = 'manual' | 'automatic';

export function useTranslations(translations: Ref<Record<string, string>>) {
  const getComponentLabel = (key: string, fallback: string) => {
    return translations.value[key] || getDefaultLocaleValue(fallback);
  };

  function getSizeTypeTranslation(key: keyof typeof SizeTypeLabel): string {
    return translations.value[SizeTypeLabel[key]] || key;
  }

  const getRoofTypeTranslation = (key: RoofTypeLabel) => {
    return (
      translations.value[`owvc_tech_data_roofType_${key.toLowerCase()}`] || key
    );
  };

  const getCabinTypeTranslation = (key: CabinTypeLabel) => {
    return (
      translations.value[`owvc_tech_data_cabinType_${key.toLowerCase()}`] || key
    );
  };

  const getDrivetrainTranslation = (key: DrivetrainLabel) => {
    return (
      translations.value[`owvc_tech_data_drivetrain_${key.toLowerCase()}`] ||
      key
    );
  };

  const getTransmissionTranslation = (key: TransmissionMode) => {
    return (
      translations.value[`owvc_tech_data_transmission_${key.toLowerCase()}`] ||
      getDefaultLocaleValue(key.toLocaleLowerCase())
    );
  };

  const getEngineTypeTranslation = (key: EngineTypeLabel) => {
    return (
      translations.value[`owvc_tech_data_engineType_${key.toLowerCase()}`] ||
      getDefaultLocaleValue(`engineType_${key.toLocaleLowerCase()}`)
    );
  };

  return {
    getComponentLabel,
    getSizeTypeTranslation,
    getRoofTypeTranslation,
    getCabinTypeTranslation,
    getDrivetrainTranslation,
    getTransmissionTranslation,
    getEngineTypeTranslation,
  };
}
